// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FormSkeleton-module__formSkeleton___pMI6B .FormSkeleton-module__label___A1XGk{margin-bottom:4px}.FormSkeleton-module__formSkeleton___pMI6B .FormSkeleton-module__input___xclE1{margin-bottom:16px}`, "",{"version":3,"sources":["webpack://./src/components/sharedComponents/FormSkeleton.module.scss"],"names":[],"mappings":"AACE,+EACE,iBAAA,CAGF,+EACE,kBAAA","sourcesContent":[".formSkeleton {\n  .label {\n    margin-bottom: 4px;\n  }\n\n  .input {\n    margin-bottom: 16px;\n  }\n\n  .button {\n    //bob\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formSkeleton": `FormSkeleton-module__formSkeleton___pMI6B`,
	"label": `FormSkeleton-module__label___A1XGk`,
	"input": `FormSkeleton-module__input___xclE1`
};
export default ___CSS_LOADER_EXPORT___;
